import { Component, Input } from '@angular/core';
import { Common } from '@trimblemaps/trimblemaps-js';
import { RouteService } from 'src/app/services/route.service';
import { Route } from 'src/app/_models/view/route';
import { RouteOptimization } from 'src/app/_models/trimblemaps';

@Component({
  selector: 'app-route-optimization',
  templateUrl: './route-optimization.component.html',
})
export class RouteOptimizationComponent {
  @Input() route: Route;

  optimizationEnum = Common.RouteOptimization;

  constructor(private routeService: RouteService) {}

  optimizeStops(optimization: RouteOptimization) {
    this.routeService.setRouteOptimization(this.route.id, optimization);
  }
}
